module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-2.0c4d0fde.webp";